<template>
  <main class="app_layout">
    <div class="app_layout-content">
      <slot></slot>
    </div>

    <VNav
        v-if="isNavVisible"
        @showHelp="enableHelp"
    />
    <HelpSlides
        v-if="showHelp"
        @close="closeHelp"
    />

  </main>
</template>

<script>
import VNav from "@/components/VNav.vue";
import HelpSlides from "@/components/home/HelpSlides.vue";
import i18n from "@/i18n";

export default {
  name: "VAppLayout",
  components: {VNav, HelpSlides},
  props: {
    isNavVisible: {type: Boolean, default: true},
    showHelp: {type: Boolean, default: false}

  },
  emits: ['closeHelp'],
  mounted() {
    i18n.locale = this.$store.getters.getPrefLangCode;
    // this.handleShowHelp();
  },
  methods: {
    closeHelp() {
      console.log('closeHelp')
      localStorage.setItem('helpSlidesShown' + this.getLocaleType(), 'true');
      this.showHelp = false;
      this.$emit('closeHelp');
    },
    enableHelp() {
      console.log('enableHelp')
      this.showHelp = true;
    },
    handleShowHelp() {
      console.log('handleShowHelp')
      if (localStorage.getItem('helpSlidesShown' + this.getLocaleType()) === null) {
        this.enableHelp();
      }
    },
    getLocaleType() {
      return this.$store.getters.getStoreMode
    },

  }
}
</script>

<style lang="scss" scoped>
@import "src/scss/assets/variables";

::v-deep .nav {
  width: 100%;
  height: $nav_bottom_height;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  border-top: 1px solid #0000004D;
  z-index: 10;
  background: white;

  //&:before {
  //    content: '';
  //    position: absolute;
  //    bottom: $nav_bottom_height;
  //    left: 0;
  //    right: 0;
  //    height: 1px;
  //    background-color: #0000004D;
  //}

  ul {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: space-around;

    li {
      list-style: none;
      height: 100%;
      display: flex;
      align-items: center;

      a {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        width: 48px;
        color: $color_grey_dusty;

        &:is(.router-link-active) {
          color: $color_violet_electric;

          & > svg {
            path {
              fill: $color_violet_electric;
            }
          }
        }

        svg {
          flex-shrink: 0;

          &:is(.nav_arrow) {
            display: none;
          }

          &:is(.nav_icon) {
            height: 24px;
          }
        }

        p {
          margin: 0;

          span {
            display: none;
          }
        }
      }
    }
  }
}

.app_layout {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.app_layout-content {
  flex: 1 1;
  //padding: 0 24px;
  overflow: scroll;
}
</style>
